<template>
  <div>
    <div class="page-header">
      <div
        class="page-header-content container-fluid header-elements-md-inline"
      >
        <div class="d-flex">
          <div class="page-title">
            <h4 class="font-weight-semibold">
              Periodo {{ period.PS_PERIODO_NOME }}
            </h4>
            <div class="text-muted">
              Referente à {{ period.PS_PERIODO_REFERENCIA }}!
            </div>
          </div>
          <a href="#" class="header-elements-toggle text-body d-md-none"
            ><i class="icon-more"></i
          ></a>
        </div>
        <loading-data v-if="isLoading"></loading-data>
        <div v-else class="header-elements d-none py-0 mb-3 mb-md-0">
          <ul class="nav nav-pills justify-content-end align-items-center">
            <li class="nav-item mr-2">
              <select
                name="unit"
                id="unit"
                class="form-control form-control-lg"
                v-model="unityId"
              >
                <option value="">Selecione uma unidade</option>
                <option
                  v-for="unit in units"
                  :key="unit.PS_UNIDADE_ID"
                  :value="unit.PS_UNIDADE_ID"
                >
                  {{ unit.PS_UNIDADE_NOME }}
                </option>
              </select>
            </li>
            <li class="nav-item mr-2">
              <a
                href="#tab-customers"
                class="nav-link btn btn-sm btn-nav btn-outline-dark active"
                data-toggle="tab"
                ><i class="fas fa-user-tag mr-2"></i>
                Clientes
              </a>
            </li>
            <li class="nav-item mr-2">
              <a
                href="#tab-stick-notes"
                class="nav-link btn btn-sm btn-nav btn-outline-dark"
                data-toggle="tab"
                ><i class="far fa-sticky-note mr-2"></i>Lembretes
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content">
      <div v-if="unityId != ''" class="tab-content">
        <div class="tab-pane fade show active" id="tab-customers">
          <select-customers
            v-if="selectAgain"
            :unityId="unityId"
            :periodId="periodId"
            @selectCostumersAgain="selectCostumersAgain"
          ></select-customers>
          <customer-registered
            v-else
            :unityId="unityId"
            :periodId="periodId"
            :selectAgain="selectAgain"
            @selectCostumersAgain="selectCostumersAgain"
          ></customer-registered>
        </div>
        <div class="tab-pane fade" id="tab-stick-notes">
          <sticky-notes :unityId="unityId" :periodId="periodId"></sticky-notes>
        </div>
        <div
          class="tab-pane fade"
          v-if="selectAgain"
          id="tab-select-costumers"
        ></div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.btn-nav {
  padding: 0.6rem 1rem !important;
}
.nav-pills .nav-link:not(.active):focus,
.nav-pills .nav-link:not(.active):hover {
  color: #ccc;
}
</style>
<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import CustomerRegistered from '@/components/period/CustomerRegistered.vue'
import StickyNotes from '@/components/period/StickyNotes.vue'
import SelectCustomers from '@/components/period/SelectCustomers.vue'

export default {
  name: 'SelectClients',
  components: {
    CustomerRegistered,
    StickyNotes,
    LoadingData,
    SelectCustomers,
  },
  data() {
    return {
      periodId: this.$route.params.periodId,
      unityId: '',
      isLoading: true,
      selectAgain: true,
      StickyNotes: [],
      period: {
        PS_PERIODO_NOME: '',
        PS_PERIODO_REFERENCIA: '',
      },
      units: null,
      customers: null,
    }
  },
  watch: {},
  methods: {
    async loadPeriod() {
      try {
        this.period = await this.$store.dispatch('getPeriod', this.periodId)
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
    async loadUnits() {
      try {
        this.units = await this.$store.dispatch('getUnits')
        this.isLoading = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
    selectCostumersAgain(value) {
      this.selectAgain = value
    },
  },
  mounted() {
    this.loadPeriod()
    this.loadUnits()
  },
}
</script>
